const textbackslash = function(ps) {
	return [
		{
			type: "text",
			text: "\\",
		},
	];
};

module.exports = {
	parsers: {
		mathCommands: {
			textbackslash,
		},
		nonmathCommands: {
			textbackslash,
		},
	},
};
